<template>
  <div class="uk-container">
    <div
      class="uk-flex uk-flex-center uk-margin-bottom"
      uk-sticky="animation: uk-animation-slide-top"
    >
      <div
        class="uk-navbar-center uk-navbar-container uk-width-1-1"
        uk-navbar
      >
        <div class="uk-navbar-left">
          <div class="uk-navbar-item uk-logo uk-visible@m">
            <img
              width="90px"
              :data-src="logoPath"
              alt="Logo"
              uk-img
            >
          </div>
          <div class="uk-navbar-item uk-logo uk-hidden@m">
            <img
              width="75px"
              :data-src="logoPath"
              alt="Logo"
              uk-img
            >
          </div>
          <ul class="uk-navbar-nav uk-visible@m">
            <router-link
              active-class="uk-active"
              tag="li"
              to="/"
              exact
            >
              <a>Home</a>
            </router-link>
          </ul>
          <ul class="uk-navbar-nav uk-hidden@m">
            <router-link
              active-class="uk-active"
              tag="li"
              to="/"
              exact
            >
              <a><span uk-icon="icon: home; ratio: 1.3" /></a>
            </router-link>
          </ul>
          <ul class="uk-navbar-nav uk-hidden@m">
            <li>
              <a>
                <span uk-icon="icon: search; ratio: 1.3" />
              </a>
              <div
                class="uk-navbar-dropdown"
                uk-dropdown="mode: click; pos: bottom-justify; offset: -15; animation: uk-animation-slide-top-small; delay-hide: 0"
              >
                <ul class="uk-nav uk-navbar-dropdown-nav">
                  <input
                    v-model="searchInput"
                    tag="li"
                    class="uk-input uk-form-width-medium"
                    type="text"
                    placeholder="Search"
                  >
                  <li class="uk-nav-header">
                    Search by
                  </li>
                  <li :class="titleClass">
                    <a @click="cMobileSearchCriteria('title')">Title</a>
                  </li>
                  <li :class="previewClass">
                    <a @click="cMobileSearchCriteria('preview')">Preview</a>
                  </li>
                  <li :class="dateClass">
                    <a @click="cMobileSearchCriteria('date')">Date</a>
                  </li>
                  <li :class="badgeClass">
                    <a @click="cMobileSearchCriteria('badge')">Badge</a>
                  </li>
                  <li class="uk-nav-header">
                    Posts Order
                  </li>
                  <li :class="newOldClass">
                    <a @click="cMobilePostsOrder ('New-Old')">New-Old</a>
                  </li>
                  <li :class="oldNewClass">
                    <a @click="cMobilePostsOrder ('Old-New')">Old-New</a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="uk-navbar-center">
          <div
            tag="ul"
            class="uk-button-group uk-navbar-nav uk-visible@m"
          >
            <input
              v-model="searchInput"
              class="uk-input uk-form-width-medium"
              type="text"
              placeholder="Search"
            >
            <div class="uk-inline">
              <button
                class="uk-button uk-button-default"
                type="button"
              >
                {{ searchCriteria }}
                <span uk-icon="icon: chevron-down; ratio: 1" />
              </button>
              <div
                ref="searchInboxDropdown"
                class="uk-navbar-dropdown"
                uk-dropdown="mode: click; pos: bottom-right; animation: uk-animation-slide-top-small; delay-hide: 0"
              >
                <ul class="uk-nav uk-navbar-dropdown-nav">
                  <li><a @click="changeSearchCriteria('title')">Title</a></li>
                  <li><a @click="changeSearchCriteria('preview')">Preview</a></li>
                  <li><a @click="changeSearchCriteria('date')">Date</a></li>
                  <li><a @click="changeSearchCriteria('badge')">Badge</a></li>
                </ul>
              </div>
            </div>
          </div>
          <ul class="uk-navbar-nav uk-visible@m">
            <li>
              <a>
                {{ postsOrder }}
                <span uk-icon="icon: chevron-down; ratio: 1.1" />
              </a>
              <div
                ref="postsOrderDropdown"
                class="uk-navbar-dropdown"
                uk-dropdown="mode: click; pos: bottom-left; offset: -10; animation: uk-animation-slide-top-small; delay-hide: 0"
              >
                <ul class="uk-nav uk-navbar-dropdown-nav">
                  <li><a @click="changePostsOrder ('New-Old')">New-Old</a></li>
                  <li><a @click="changePostsOrder ('Old-New')">Old-New</a></li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="uk-navbar-right">
          <ul class="uk-navbar-nav uk-hidden@m">
            <router-link
              active-class="uk-active"
              tag="li"
              to="/about"
            >
              <a><span uk-icon="icon: info; ratio: 1.3" /></a>
            </router-link>
          </ul>
          <ul class="uk-navbar-nav uk-visible@m">
            <router-link
              active-class="uk-active"
              tag="li"
              to="/about"
            >
              <a>About</a>
            </router-link>
          </ul>
          <ul class="uk-navbar-nav uk-hidden@m">
            <router-link
              active-class="uk-active"
              tag="li"
              to="/donate"
            >
              <a><span uk-icon="icon: heart; ratio: 1.3" /></a>
            </router-link>
          </ul>
          <ul class="uk-navbar-nav uk-visible@m">
            <router-link
              active-class="uk-active"
              tag="li"
              to="/donate"
            >
              <a>Donate</a>
            </router-link>
          </ul>
        </div>
      </div>
    </div>
    <div class="uk-flex uk-flex-center uk-text-center">
      <transition
        mode="out-in"
        enter-active-class="uk-animation-fade"
        leave-active-class="uk-animation-fade uk-animation-reverse"
        appear
      >
        <router-view
          :key="$route.fullPath"
          :posts-order="postsOrder"
          :search-criteria="searchCriteria"
          :search-filter="searchInput"
        />
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      logoPath: require('@/assets/image/logo.png'),
      postsOrder: 'New-Old',
      searchCriteria: 'title',
      searchInput: '',
      newOldClass: 'uk-active',
      oldNewClass: '',
      titleClass: 'uk-active',
      previewClass: '',
      dateClass: '',
      badgeClass: ''
    }
  },
  methods: {
    changePostsOrder (selectedOrder) {
      this.postsOrder = selectedOrder
      UIkit.dropdown(this.$refs.postsOrderDropdown).hide()
    },
    changeSearchCriteria (selectedCriteria) {
      this.searchCriteria = selectedCriteria
      UIkit.dropdown(this.$refs.searchInboxDropdown).hide()
    },
    cMobilePostsOrder (selectedOrder) {
      this.postsOrder = selectedOrder
      if (selectedOrder === 'New-Old') {
        this.newOldClass = 'uk-active'
        this.oldNewClass = ''
      } else if (selectedOrder === 'Old-New') {
        this.newOldClass = ''
        this.oldNewClass = 'uk-active'
      }
    },
    cMobileSearchCriteria (selectedCriteria) {
      this.searchCriteria = selectedCriteria
      if (selectedCriteria === 'title') {
        this.titleClass = 'uk-active'
        this.previewClass = ''
        this.dateClass = ''
        this.badgeClass = ''
      } else if (selectedCriteria === 'preview') {
        this.titleClass = ''
        this.previewClass = 'uk-active'
        this.dateClass = ''
        this.badgeClass = ''
      } else if (selectedCriteria === 'date') {
        this.titleClass = ''
        this.previewClass = ''
        this.dateClass = 'uk-active'
        this.badgeClass = ''
      } else if (selectedCriteria === 'badge') {
        this.titleClass = ''
        this.previewClass = ''
        this.dateClass = ''
        this.badgeClass = 'uk-active'
      }
    }
  }
}
</script>

<style>
@import url('https://rsms.me/inter/inter.css');
html { font-family: 'Inter', sans-serif; }
@supports (font-variation-settings: normal) {
  html { font-family: 'Inter var', sans-serif; }
}
</style>
